import React from 'react';

const quickLinks = [
  { label: 'Home', view: 'home' },
  { label: 'About', view: 'about_page' },
  { label: 'Projects', view: 'projects_page' },
  { label: 'Blog', view: 'blog' },
  { label: 'Clients', view: 'clients_page' },
  { label: 'Ventures', view: 'ventures_page' },
  { label: 'Contact', view: 'contact_page' },
];

function FooterNew({ onNavigate }) {
  const handleLinkClick = (view) => {
    if (onNavigate) {
      onNavigate(view);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer id="contact" className="bg-[#111] pt-32 pb-16 px-10 md:px-20 border-t border-white/5">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-16">
        <div>
          <img
            src="/logo.png"
            alt="Rama Infra Projects Logo"
            className="w-32 h-auto object-contain mb-6"
            loading="lazy"
            decoding="async"
          />
          <p className="text-[10px] text-neutral-500 leading-relaxed uppercase tracking-widest">
            Building Infrastructure Since 2000
          </p>
        </div>
        <div>
          <h5 className="bank-gothic text-[10px] mb-8 text-white">Company</h5>
          <ul className="space-y-4 text-neutral-500 text-[10px] bank-gothic">
            <li>Rama Infra Projects</li>
            <li>Established: 7th March 2000</li>
          </ul>
        </div>
        <div>
          <h5 className="bank-gothic text-[10px] mb-8 text-white">Contact</h5>
          <ul className="space-y-4 text-neutral-500 text-[10px] bank-gothic">
            <li>Phone: 022-28943128</li>
            <li>
              <a href="mailto:ramainfrappl@yahoo.in" className="accent-text hover:text-white transition-colors">
                ramainfrappl@yahoo.in
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h5 className="bank-gothic text-[10px] mb-8 text-white">Quick Links</h5>
          <ul className="space-y-3 text-neutral-500 text-[10px] bank-gothic">
            {quickLinks.map((link) => (
              <li key={link.view}>
                <button
                  type="button"
                  onClick={() => handleLinkClick(link.view)}
                  className="text-left hover:text-[#c49b66] transition-colors touch-manipulation"
                >
                  {link.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
}

export default FooterNew;
